module.exports = __webpack_public_path__ + "themify.e23a7dcaefbde4e74e26.ttf";


//////////////////
// WEBPACK FOOTER
// /builds/faixa-azul/faixa-azul-fad-web/node_modules/cd-themify-icons/fonts/themify.ttf
// module id = ../../../../cd-themify-icons/fonts/themify.ttf
// module chunks = styles